import { Injectable, inject } from '@angular/core';
import { ApiService } from '@letly/services';
import { environment } from '../../../../../env/environment';
import { Observable } from 'rxjs';
import { ApiResponse, ContractModel } from '@letly/models';

export interface ContractClausePayload {
  id?: string;
  content: string;
  section?: string;
  parentClauseId?: string;
}

@Injectable({providedIn: 'root'})
export class ContractApiService {
  private api = inject(ApiService);
  private base = environment.listingBaseUrl;

  getContract(propertyId: string, contractId: string): Observable<ApiResponse<ContractModel>> {
    return this.api.get(`${this.base}/v1/landlords/self/properties/${propertyId}/contracts/${contractId}`);
  }

  createDraft(propertyId: string, contractId: string): Observable<ApiResponse<ContractModel>> {
    return this.api.post(`${this.base}/v1/landlords/self/properties/${propertyId}/contracts/${contractId}/draft`, {});
  }

  updateDraft(propertyId: string, contractId: string, clauses: ContractClausePayload[]): Observable<ApiResponse<ContractModel>> {
    return this.api.put(
      `${this.base}/v1/landlords/self/properties/${propertyId}/contracts/${contractId}`,
      {
        clauses: clauses.map(c => ({
          ...(c.id ? {id: c.id} : {}),
          content: c.content,
          ...(c.section ? {section: c.section} : {}),
          ...(c.parentClauseId ? {parentClauseId: c.parentClauseId} : {})
        }))
      }
    );
  }

  submit(propertyId: string, contractId: string): Observable<ApiResponse<ContractModel>> {
    return this.api.post(`${this.base}/v1/landlords/self/properties/${propertyId}/contracts/${contractId}/submit`, {});
  }
}
